import {
  assembleListPartnershipPartnerOptionsResult,
  buildLookupPartnershipPartnerPermissionResult,
  catalogUnknownPartnershipPermissionMeta,
  type ListPartnershipPartnerOptionsResult,
  type LookupPartnershipPartnerPermissionResult,
} from "./partnershipPartnerOptions";

/** Pilot orgs allowed to use managed-ads Instagram partner post UI + APIs. Remove when GA. */
const MANAGED_ADS_PARTNER_POST_PILOT_ORG_IDS = new Set<string>([
  // Apple Review Org
  "ORe05ba45c-a4fd-43d9-87b5-754c3f937475",
]);

export function isManagedAdsPartnerPostsEnabledForOrg(
  organizationId: string | null | undefined
): boolean {
  const id = organizationId?.trim();
  return Boolean(id && MANAGED_ADS_PARTNER_POST_PILOT_ORG_IDS.has(id));
}

export function emptyListPartnershipPartnerOptionsResult(args?: {
  advertiser_page_id?: string;
  advertiser_instagram_user_id?: string;
}): ListPartnershipPartnerOptionsResult {
  return assembleListPartnershipPartnerOptionsResult({
    facebook_pages: [],
    instagram_accounts: [],
    advertiser_identity: {
      ...(args?.advertiser_page_id
        ? { page_id: args.advertiser_page_id.trim() }
        : {}),
      ...(args?.advertiser_instagram_user_id
        ? { instagram_user_id: args.advertiser_instagram_user_id.trim() }
        : {}),
      validation_messages: [],
      partnership_permissions_loaded: false,
      partnership_permissions_count: 0,
    },
  });
}

export function disabledLookupPartnershipPartnerPermissionResult(): LookupPartnershipPartnerPermissionResult {
  return buildLookupPartnershipPartnerPermissionResult({
    permissionMeta: catalogUnknownPartnershipPermissionMeta(),
    isEligibleForBrandedContent: null,
    isAdAccountPage: false,
  });
}

export const MANAGED_ADS_PARTNER_POSTS_DISABLED_MESSAGE =
  "Partnership posts are not enabled for this organization.";
